module.exports = __webpack_public_path__ + "img/s8-300x103.43677e71.jpg";